
<div class="button-wrapper">
  <div *ngIf="!isArmed; else confirmButtons" class="main-button" (click)="isArmed = true">
    <ng-content>
    </ng-content>
  </div>

  <ng-template #confirmButtons>
    <button class="confirm-button btn btn-sm mr-2" [ngClass]="confirmButtonClasses" (click)="confirm.emit()">
      {{ i18nBaseKey + '.' + confirmTranslationKey | transloco }}
    </button>

    <button class="abort-button btn btn-sm btn-light" (click)="isArmed = false">
      <fa-icon [icon]="['fal', 'times']"></fa-icon>
    </button>
  </ng-template>
</div>
